import Vue from 'vue'
import confirm from '@/components/confirmation-modal/confirm.vue'
export default Vue.extend({
  name: 'ReonfirmEmail',
  components: {
    confirm
  },
  data() {
    return {
      valid: true,
      reconfirmRegisterForm: {
        token: this.$route.params.token,
        type: 'UPDATE_EMAIL_CONFIRMATION'
      }
    }
  },

  created() {
    this.handleVerifyToken()
  },

  methods: {
    async reconfirmRegister() {
      await this.$store
          .dispatch('confirmRegister', this.$route.params.token)
          .then(() => {
            // this.$router.push({ path: '/register/complete' })
          }).catch(() => {
            this.valid = false
          })
    },

    async handleVerifyToken() {
      await this.$store
          .dispatch('verifyToken', this.reconfirmRegisterForm)
          .then(() => {
            this.reconfirmRegister()
          })
          .catch(() => {
            this.valid = false
          })
    },
    toDashboard() {
      this.$router.push('/dashboard')
    }
  }
})
